import React, { useState } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import MaterialGroupSelect from "./MaterialGroupSelect";
import MaterialLocationSelect from "./MaterialLocationSelect";
import { toast } from "react-toastify";
import LoadingOverlay from "./LoadingOverlay";
import ConfirmDialog from "./ConfirmDialog";

function NewMaterial() {
  const listUnit = ["ROLL", "SHEET", "PLY", "KG", "PCS", "RIM"];
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedMatGroup, setSelectedMatGroup] = useState(null);
  const [productName, setProductName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [productUnit, setProductUnit] = useState(listUnit[0]);
  const [productLocation, setProductLocation] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);
  const [checkCode, setCheckCode] = useState(false);
  const [appCode, setAppCode] = useState("");

  const handleProductUnitChange = (e) => {
    setProductUnit(e.target.value);
  };
  const handleProductLocationChange = (locationId) => {
    setProductLocation(locationId);
  };

  const handleProductNameChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    setProductName(uppercaseValue);
  };

  const handleProductCodeChange = (e) => {
    setProductCode(e.target.value);
    setCheckCode(false);
  };

  const handleMatGroupChange = (GroupId) => {
    setSelectedMatGroup(GroupId);
  };

  const checkProductCode = async () => {
    if (!selectedGroup?.group_code || !productCode) {
      toast.warning("Isi Group Code dan Product Code dulu");
      return;
    }

    const fullCode = `${selectedGroup.group_code}${productCode}`;

    try {
      const response = await axios.get(
        `https://eps.elkomprintama.com/api/store/store/check_product_code`,
        {
          params: {
            product_code: fullCode,
          },
          withCredentials: true, // only if you're using cookies/session
        },
      );

      if (response.data.exists) {
        toast.error(`❌ Kode produk "${fullCode}" sudah dipakai!`);
        setAppCode();
      } else {
        toast.success(`✅ Kode produk "${fullCode}" tersedia`);
        setAppCode(fullCode);
        setCheckCode(true);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.msg || "Gagal cek product code, coba lagi",
      );
      console.error("Product code check error:", error);
    }
  };

  const insertOrder = async (e) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `https://eps.elkomprintama.com/post/api/store/mats`,
        {
          product_name: productName,
          product_code: appCode,
          group_id: selectedMatGroup,
          unit: productUnit,
          product_location_id: productLocation,
        },
      );
      if (response.status === 200) {
        // Access the 'msg' property from the response data
        toast.success(response.data.msg); // This will display the success message
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!productName || !productCode || !selectedMatGroup || !productCode) {
      toast.warning("Please fill in all required fields");
      return;
    }
    if (!checkCode) {
      toast.warning("Please check product code first");
      return;
    }
    setShowConfirm(true);
    setUploadPending(true);
  };

  return (
    <>
      <div className={`w-full  rounded-lg `}>
        <label
          className={`block uppercase text-white  mb-2 tracking-wide  text-2xl text-center  font-bold `}
        >
          New Material
        </label>
      </div>
      <div className="relative  overflow-x-auto bg-gray-100 shadow-md px-5 rounded-lg">
        <form className="my-5" onSubmit={handleSubmit}>
          <MaterialLocationSelect
            onChangeList={handleProductLocationChange}
          ></MaterialLocationSelect>
          <MaterialGroupSelect
            onChangeList={handleMatGroupChange}
            onGroupObjectChange={(group) => {
              setSelectedGroup(group);
            }}
          />
          <div className="field w-full my-2">
            <div className="control w-full  ">
              <div className="flex flex-wrap -mx-3 mb-5">
                <div className="w-full md:w-5/6 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="product_name"
                  >
                    Product Name
                  </label>
                  <input
                    className="appearance-none block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="product_name"
                    name="product_name"
                    type="text"
                    placeholder="Format: 'Nama Product' SIZE 'Ukuran x panjang'----CONTOH = WOODFREE SIZE 106MM x 500M  "
                    value={productName}
                    onChange={handleProductNameChange}
                  />
                </div>
                <div className="w-full md:w-1/6 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="product_code"
                  >
                    Product Code
                  </label>
                  <div className="flex items-center space-x-2">
                    {/* Group Code (disabled) */}
                    <input
                      type="text"
                      value={selectedGroup?.group_code || ""}
                      disabled
                      className="w-1/3 border border-gray-300 rounded px-3 py-2 bg-gray-100 text-gray-700"
                    />

                    {/* Separator Dash */}
                    <span className="text-gray-600 font-bold">-</span>

                    {/* Product Code Input */}
                    <input
                      className="w-1/3 border bg-white border-green-400 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-white"
                      id="product_code"
                      name="product_code"
                      type="text"
                      placeholder="Code"
                      value={productCode}
                      onChange={handleProductCodeChange}
                    />

                    {/* Check Button */}
                    <button
                      type="button"
                      onClick={checkProductCode}
                      className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-3 rounded text-sm"
                    >
                      Check
                    </button>
                  </div>
                  {/* Preview Final Code Below */}
                  <p className="text-xs text-gray-500 mt-1">
                    Final Code:{" "}
                    <strong>
                      {selectedGroup?.group_code || ""}
                      {productCode}
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full mb-5 ">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="product_unit"
            >
              UNIT
            </label>
            <select
              className="block appearance-none w-full border border-green-400 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="product_unit"
              name="product_unit"
              onChange={handleProductUnitChange}
            >
              {Array.isArray(listUnit) ? (
                listUnit.map((data, index) => (
                  <option value={data} key={`listU-${index}`}>
                    {data}
                  </option>
                ))
              ) : (
                <option value="" key="empty-option">
                  Loading... {/* or any other placeholder */}
                </option>
              )}
            </select>
          </div>
          <div className="w-full ">
            <Button fullSized type="submit">
              Insert
            </Button>
          </div>
          {isLoading && <LoadingOverlay message="Uploading" />}
          {showConfirm && uploadPending && (
            <ConfirmDialog
              message="Are you sure you want to insert the data?"
              onConfirm={() => {
                setShowConfirm(false);
                insertOrder();
                setProductName("");
                setProductCode("");
                setAppCode("");
                setCheckCode(false);
                setAppCode("");
              }}
              onCancel={() => {
                setShowConfirm(false);
                setUploadPending(false);
              }}
            />
          )}
        </form>
      </div>
    </>
  );
}

export default NewMaterial;
